exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".set-small-dialog .el-dialog__body[data-v-3f284959]{height:300px}", ""]);

// exports
